const config = {
    API_URL: "https://api.skynyx.ai/public/api",
};

export default config;
